import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { hideBackButton: any }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      footerContainer: {
        justifyContent: props.hideBackButton ? 'end' : 'space-between',
        padding: '8px 24px 0px 24px',
        background: 'transparent',
        alignItems: 'center'
      },
      footerLeftButton: {
        minWidth: '400px',
        maxWidth: 'fit-content',
        [theme.breakpoints.down('lg')]: {
          minWidth: '375px',
          maxWidth: 'fit-content'
        },
        '& > span': {
          padding: '0px 0px 0px 10px'
        }
      }
    })
  );
